import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { IconButton } from '../IconButton';
/**
 * __Profile__
 *
 * A profile button which takes an icon/avatar component can be that can be
 * passed into `AtlassianNavigation`'s `renderProfile` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#profile)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */
export var Profile = /*#__PURE__*/forwardRef(function (props, ref) {
  var labelProp = props.label,
    tooltip = props.tooltip;
  var label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');

  // All other implementations of IconButton within the components are using spread props, so
  // to use explicit props could cause regressions.
  // TODO: Remove these spread props for better static analysis
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  return /*#__PURE__*/React.createElement("div", {
    role: "listitem"
  }, /*#__PURE__*/React.createElement(IconButton, _extends({
    label: label,
    ref: ref
  }, props)));
});

// This exists only to extract props.
// eslint-disable-next-line @repo/internal/react/use-noop
export default (function (props) {});